import * as ROUTES from '../common/routes';
import React, { useState } from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import { COLORS, FONTS, FONT_WEIGHT } from '../common/theme';
import clsx from 'clsx';
import {
  StyleRules,
  Theme,
  createStyles,
  makeStyles,
} from '@material-ui/core/styles';

interface IProps {
  type?: string;
  className: string;
  placeholder: string;
  passedRef: any;
  maxLength: number;
}

const useStyles = makeStyles(
  (theme: Theme): StyleRules =>
    createStyles({
      inputContainerStyle: {
        position: 'relative',
        border: 'gray solid 1px',
      },
      textStyle: {
        width: '100%',
        background: 'transparent',
        resize: 'none',
        overflow: 'hidden',
        boxShadow: 'none !important',
        fontFamily: FONTS.roboto,
        padding: '20px',
        fontSize: '16px',
        lineHeight: '22px',
        border: 'none',
      },
      remainingStyle: {
        position: 'absolute',
        right: 0,
        bottom: 0,
        textAlign: 'right',
        fontFamily: FONTS.roboto,
        fontSize: '12px',
        color: COLORS.textGray,
        padding: '4px',
      },
      [`@media (max-width: 800px)`]: {
        textStyle: {
          margin: '0 0 20px 0',
          textAlign: 'left',
        },
      },
    })
);

const InputComponent = ({
  type,
  className,
  placeholder,
  passedRef,
  maxLength,
}: IProps): JSX.Element => {
  const classes = useStyles();
  const [currentInput, setInput] = useState('');

  const onChange = (event) => {
    setInput(event?.target?.value);
  };

  const remaining = maxLength - currentInput?.length;

  if (type === 'text') {
    return (
      <div className={clsx(classes.inputContainerStyle, className)}>
        <input
          className={classes.textStyle}
          placeholder={placeholder}
          maxLength={maxLength}
          ref={passedRef}
          type="text"
          onChange={onChange}
        />
        <div className={classes.remainingStyle}>{remaining}</div>
      </div>
    );
  }

  return (
    <div className={clsx(classes.inputContainerStyle, className)}>
      <TextareaAutosize
        className={classes.textStyle}
        placeholder={placeholder}
        maxLength={maxLength}
        ref={passedRef}
        onChange={onChange}
      />
      <div className={classes.remainingStyle}>{remaining}</div>
    </div>
  );
};

export default InputComponent;
